import React, {useImperativeHandle, useRef} from 'react'
import WizModal from '../../../../components/modal/WizModal'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import {deletePostApi} from '../../../../apis/post/deletePostApi'
import useNavigation from '../../../../hooks/useNavigation'
import {deletePTSLeaderApi} from '../../../../apis/leader/payToSee'

interface IProps {
    className?: string
    id?: string
    afterDelete?: () => void
}

const DeletePTSLeaderModal = ({className, id, afterDelete}: IProps, ref: any) => {
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    const onClickDelete = async () => {
        await deletePTSLeaderApi(id)
            .then(data => {
                data.status !== 200 ? alert('Failed to delete leader. Please try again.') : alert('Delete Pts leader')
                afterDelete()
            })
            .catch(err => {
                console.error('Error deleting PTS leader:', err)
                alert('Failed to delete PTS leader. Please try again.')
            })

        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Remove Post'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 리더를 정말 삭제하시겠습니까? </Text>

                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Remove'} type={'red'} className={'flex-1'} onClick={() => onClickDelete()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(DeletePTSLeaderModal)
